import { render, staticRenderFns } from "./AGCInput.vue?vue&type=template&id=4fdb2ede&scoped=true&"
import script from "./AGCInput.vue?vue&type=script&lang=js&"
export * from "./AGCInput.vue?vue&type=script&lang=js&"
import style0 from "./AGCInput.vue?vue&type=style&index=0&id=4fdb2ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdb2ede",
  null
  
)

export default component.exports